<template>
    <div class="phoneFeeDetail flex_v">
        <!-- 分账管理-话费账单-查看详情 -->
        <!-- 标题 -->
        <div class="titleBox flex-row ite-c">
            <b>{{topTitle.title}}</b>
            <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
            <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
        </div>


        <!-- 第一行内容 -->
        <div class="orderDeBotpC flex-row jus-b">
            <!-- ========================================== 账单信息-start ========================================== -->
            <div class="billInfo">
                <p class="boxTitle boxs">账单信息</p>
                <div class="comBox boxs flex_v_hL_vU">
                    <div class="topLine flex_h_hS_vC">
                        <p>
                            <span class="grayT">网点：</span>
                            <span>{{bill_info.website}}</span>
                        </p>
                    </div>
                    <div class="midArea flex_1 flex_v_hL_vU">
                        <p>
                            <span class="grayT">用户：</span>
                            <span>{{bill_info.userMemberName}}</span>
                        </p>
                        <p>
                            <span class="grayT">手机号：</span>
                            <span>{{bill_info.phoneNumber}}</span>
                        </p>
                        <p>
                            <span class="grayT">激活时间：</span>
                            <span>{{bill_info.activeTime}}</span>
                        </p>
                        <p>
                            <span class="grayT">导入时间：</span>
                            <span>{{bill_info.importTime}}</span>
                        </p>
                    </div>
                    <p class="botLine flex_h_hL_vC">
                        话费：￥<b>{{bill_info.billFee}}</b>
                    </p>
                </div>
            </div>
            <!-- =========================================== 账单信息-end =========================================== -->

            
            <!-- ========================================== 分账信息-start ========================================== -->
            <div class="subAccountInfo">
                <p class="boxTitle boxs">分账信息</p>
                <div class="comBox boxs flex_v_hL_vU">
                    <div class="topLine flex_h_hS_vC">
                        <div class="flex_h_hL_vC">
                            <img src="@/assets/images/operate/SplitBillManage/Order/icon_calendar.png" alt="" class="boxs">
                            <span>{{sub_account_info.processingTime}}</span>
                        </div>
                        <span class="lightGreenT"></span>
                    </div>
                    <div class="midArea flex_1 flex_v_hL_vU">
                        <p>
                            <span class="grayT">分账ID：</span>
                            <span>{{sub_account_info.code}}</span>
                        </p>
                        <p>
                            <span class="grayT">分账对象：</span>
                            <span>{{sub_account_info.memberName}}</span>
                        </p>
                        <p>
                            <span class="grayT">分账标识：</span>
                            <span>{{sub_account_info.configNames}}</span>
                        </p>
                    </div>
                    <p class="botLine flex_h_hL_vC">
                        分账金额：￥<b>{{sub_account_info.commission}}</b>
                    </p>
                </div>
            </div>
            <!-- =========================================== 分账信息-end =========================================== -->

            
            <!-- ========================================== 资金流水信息-start ========================================== -->
            <!-- 资金流水信息-无数据 -->
            <div class="moneyFlowInfo" v-if="money_flow_info.length <=0">
                <p class="boxTitle boxs">资金流水信息</p>
                <div class="noData flex_h_hC_vC">
                    <img src="@/assets/images/operate/SplitBillManage/Order/noMoneyFlowData.png" alt="" class="boxs">
                </div>
            </div>

            <!-- 资金流水信息-有数据 -->
            <div class="moneyFlowInfo" v-if="money_flow_info.length>0">
                <p class="boxTitle boxs">资金流水信息</p>
                <div class="topLine2 boxs flex_h_hL_vC">
                    <span class="grayT">对象：</span>
                    <span>{{money_flow_info[0].MEMBER_NAME}}</span>

                    <span v-if="money_flow_info[0].STATE" class="grayT" style="margin-left:24px">资金类型：</span>
                    <span v-if="money_flow_info[0].STATE">{{money_flow_info[0].STATE}}</span>
                </div>
                <div class="botTable boxs tableTheadOrange">
                    <el-table :data="money_flow_info"
                            style="width: 100%;"
                            max-height="147"
                            border
                            fit
                            highlight-current-row
                            tooltip-effect="dark"
                    >
                        <el-table-column label="分账标识" prop="CONFIG_NAME" min-width="88" header-align="center" align="center"
                                        show-overflow-tooltip></el-table-column>
                        <el-table-column label="资金流水ID" prop="LOG_SERIAL_NO" min-width="140" header-align="center" align="center"
                                        show-overflow-tooltip></el-table-column>
                        <el-table-column label="资金金额" prop="FEE" min-width="88" header-align="center" align="center"
                                        show-overflow-tooltip>
                            <template slot-scope="scope">
                                ￥{{(scope.row.FEE).toFixed(2)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="生成时间" prop="LOG_TIME" min-width="143" header-align="center" align="center"
                                        show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" fixed="right" width="88" header-align="center" align="center"
                                        show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-button @click="showAuditDialog(scope)"
                                            v-if="scope.row.STATUS != '1'"
                                            class="greenT"
                                            icon="el-icon-document"
                                            type="text"
                                            title="稽核冲账">稽核冲账
                                </el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>
            <!-- =========================================== 资金流水信息-end =========================================== -->
        </div>

        
        <!-- ========================================== 稽核冲账日志-start ========================================== -->
        <div class="auditAccountLog" v-if="audit_account_log.length>0">
            <div class="grayTltleLine boxs">稽核冲账日志</div>
            <div class="tableTheadDarkGray boxs">
                    <el-table :data="audit_account_log"
                            style="width: 100%;"
                            max-height="189"
                            border
                            fit
                            highlight-current-row
                            tooltip-effect="dark"
                    >
                        <el-table-column label="操作时间" prop="LOG_TIME" width="160" header-align="center" align="center"
                                        show-overflow-tooltip></el-table-column>
                        <el-table-column label="资金流水ID" prop="LOG_SERIAL_NO" width="200" header-align="center" align="center"
                                        show-overflow-tooltip></el-table-column>
                        <el-table-column label="稽核冲账金额" prop="AUDIT_FEE" width="110" header-align="center" align="center"
                                        show-overflow-tooltip>
                            <template slot-scope="scope">
                                ￥{{(scope.row.AUDIT_FEE).toFixed(2)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作对象" prop="NAME" width="130" header-align="center" align="center"
                                        show-overflow-tooltip></el-table-column>
                        <el-table-column label="当前资金金额" prop="PRESENT_FEE" width="110" header-align="center" align="center"
                                        show-overflow-tooltip>
                            <template slot-scope="scope">
                                ￥{{(scope.row.PRESENT_FEE).toFixed(2)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="稽核理由" prop="AUDIT_REASON" min-width="200" header-align="left" align="left"
                                        show-overflow-tooltip></el-table-column>

                    </el-table>
                </div>
        </div>
        <!-- =========================================== 稽核冲账日志-end =========================================== -->



        <!-- =========================================== 稽核冲账弹窗-start =========================================== -->
        <el-dialog width="600px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
                :before-close="beforeClose" :close-on-click-modal=false :show-close="true">
            <el-form ref="form" :rules="rules" :model="postForm" label-width="94px">

                <el-row>
                    <el-col :span="11">
                        <el-form-item label="稽核冲账：" prop="auditFee">
                            <el-input
                                    v-model="postForm.auditFee"
                                    placeholder="请输入稽核冲账金额"
                                    maxlength="30" clearable
                                    @input="e => postForm.auditFee = validForbid(e)"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <span style="font-weight:700; line-height:40px; margin-left:12px; color:#34333A;">元</span>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="资金金额：" prop="presentFee">
                            <span style="font-weight:700; line-height:40px; color:#34333A;">
                                {{postForm.presentFee}}
                            </span>
                            <span style="font-weight:700; line-height:40px; margin-left:12px; color:#34333A;">元</span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="稽核理由：" prop="auditReason">
                            <el-input v-model.trim="postForm.auditReason"
                                        placeholder="输入稽核理由"
                                        maxlength="180"
                                        clearable
                                        type="textarea"
                                        :rows="3"
                                        @input="e => postForm.auditReason = validForbid(e)"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>

            <span slot="footer" class="dialog-footer flex-row jus-c">
                <button @click="beforeClose" class="butStyle cancelBtn">取 消</button>
                <button @click="validateForm" class="butStyle submitGreenBtn">确 定</button>
            </span>
        </el-dialog>
        <!-- =========================================== 稽核冲账弹窗-end =========================================== -->

    </div>
</template>

<script>
    import SrFilter from '@/components/Common/Filter/Filter'
    import {formatDate} from '@/utils/dateFormatter';
    import{
        getBillInfoAPI, //详情-获取账单信息
        getSubAccountInfoAPI, //详情-获取分账信息
        getMoneyFlowInfoAPI, //详情-获取资金流水信息
    } from '@/api/Operate/SplitBillManage/phoneFee.js';
    import{
        getAuditAccountLogAPI, //详情-获取稽核冲账信息
        getWalletBalanceAPI, //详情-稽核冲账之前需要查询钱包余额
        auditAccountAPI, //详情-稽核冲账
    } from '@/api/Operate/SplitBillManage/order.js';

    // “稽核冲账”弹窗提交数据
    const defaultPostForm = {
        auditFee: '',// 稽核冲账
        presentFee: null,// 资金金额
        auditReason: null,//稽核理由
    }


    export default {
        name: 'phoneFeeDetail',
        data() {
            return {
                // 标题
                topTitle: {
                    title: '分账管理',
                    subTit: '话费账单',
                    thirdTit: '查看详情',
                },

                // 路由携带参数
                routerParam: {
                    phoneNumber: null, //号码
                    memberId: null, //分账对象
                    code: null //分账ID
                },


                // 账单信息
                bill_info: {
                    website: '-', // 网点
                    userMemberName: '-', // 用户
                    phoneNumber: '-', // 手机号
                    activeTime: '-', // 激活时间
                    importTime: '-', // 导入时间
                    billFee: '-', // 话费
                },

                // 分账信息
                sub_account_info: {
                    processingTime: '-', // 日期时间
                    code: '-', // 分账ID
                    memberName: '-', // 分账对象
                    configNames: '-', // 分账标识
                    commission: '-', // 分账金额
                },

                // 资金流水信息
                money_flow_info: [],

                // 稽核冲账信息
                audit_account_log: [],


                // “稽核冲账”弹窗数据
                postForm: Object.assign({}, defaultPostForm),
                // 稽核冲账窗口是否显示
                dialogFormVisible: false,
                // 弹窗标题
                dialogMap: {
                    auditAccount: '稽核冲账',
                },
                dialogTitle: '',
                rules: {
                    auditFee: [{required: true, message: '请输入稽核冲账金额', trigger: 'blur'}],
                },
               
            }
        },
        components: {
            SrFilter
        },
        computed: {},
        created() {
            // 获取路由携带参数
            this.initRouterParam();
        },
        methods: {
            // 获取路由携带参数
            initRouterParam() {
                const phoneNumber = this.$route.query.phoneNumber;
                const memberId = this.$route.query.memberId;
                const code = this.$route.query.code;

                this.routerParam.phoneNumber = phoneNumber;
                this.routerParam.memberId = memberId;
                this.routerParam.code = code;

                // 详情-获取账单信息
                this.getBillInfo();
                // 详情-获取分账信息
                this.getSubAccountInfo();
                // 详情-获取资金流水信息
                this.getMoneyFlowInfo();
                // 详情-获取稽核冲账信息
                this.getAuditAccountLog();
            },
            
            // 详情-获取账单信息
            async getBillInfo() {
                try {
                    const result = await getBillInfoAPI(this.routerParam);
                    this.bill_info = result.data;

                    this.bill_info.billFee = (this.bill_info.billFee).toFixed(2);
                } catch (e) {
                    console.log(e)
                }
            },
            // 详情-获取分账信息
            async getSubAccountInfo() {
                try {
                    const result = await getSubAccountInfoAPI(this.routerParam);
                    this.sub_account_info = result.data;

                    this.sub_account_info.commission = (this.sub_account_info.commission).toFixed(2);
                } catch (e) {
                    console.log(e)
                }
            },
            // 详情-获取资金流水信息
            async getMoneyFlowInfo() {
                try {
                    const result = await getMoneyFlowInfoAPI(this.routerParam);
                    this.money_flow_info = result.data;
                } catch (e) {
                    console.log(e)
                }
            },
            // 详情-获取稽核冲账信息
            async getAuditAccountLog() {
                try {
                    const result = await getAuditAccountLogAPI(this.routerParam);
                    this.audit_account_log = result.data;
                } catch (e) {
                    console.log(e)
                }
            },


            // 显示稽核冲账弹窗
            showAuditDialog(scope) {
                this.dialogTitle = 'auditAccount';
                this.dialogFormVisible = true;

                const rowDate = JSON.parse(JSON.stringify(scope.row));
                this.postForm.presentFee = rowDate.FEE;
                this.postForm.logSerialNo = rowDate.LOG_SERIAL_NO;
            },
            // 弹窗关闭前
            beforeClose() {
                this.resetData()
            },
            // 关闭弹窗
            closeDialog() {
                this.resetData()
            },
            // 重置表单
            resetData() {
                this.dialogFormVisible = false
                this.$nextTick(() => {
                    this.$refs['form'].clearValidate()
                })
                this.postForm = Object.assign({}, defaultPostForm)
            },

            // 验证表单-点击弹窗的“确定”按钮
            validateForm() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitForm()
                    } else {
                        this.dialogFormVisible = true
                    }
                })
            },
            // 提交表单
            async submitForm() {
                if (this.postForm.auditFee == 0) {
                    this.$message.error('稽核冲账金额不能为0');
                    return;
                }
                if (parseFloat(this.postForm.auditFee) > parseFloat(this.postForm.presentFee)) {
                    this.$message.error('稽核冲账金额不能大于资金金额');
                    return;
                }

                // // 稽核冲账之前需要查询钱包余额
                // try {
                //     const result1 = await getWalletBalanceAPI({"memberId":this.routerParam.memberId})
                //     let walletBalance = result1.data.balance;
                //     // 如果钱包余额不足，返回提示信息
                //     if (parseFloat(this.postForm.auditFee) > parseFloat(walletBalance)) {
                //         this.$message.error('钱包余额不足，当前余额为：' + walletBalance + '元');
                //         return;
                //     }
                    // 如果钱包余额充足，稽核冲账
                    const param = {
                        logSerialNo: this.postForm.logSerialNo, //资金流水id
                        orderId: this.routerParam.phoneNumber, //号码
                        subAccountId: this.routerParam.code, //分账ID
                        auditFee: parseFloat(this.postForm.auditFee)*100, //稽核冲账金额，单位分
                        presentFee: parseFloat(this.postForm.presentFee)*100, //当前资金金额，单位分
                        auditReason: this.postForm.auditReason, //理由
                        auditMemberId: this.routerParam.memberId, //稽核冲账对象id
                    };
                    try {
                        const result = await auditAccountAPI(param)
                        this.$message.success('稽核冲账成功')
                        // 重新获取数据
                        // this.getBillInfo();// 详情-获取账单信息
                        this.getSubAccountInfo();// 详情-获取分账信息
                        this.getMoneyFlowInfo();// 详情-获取资金流水信息
                        this.getAuditAccountLog();// 详情-获取稽核冲账信息

                        // 关闭弹窗
                        this.closeDialog()
                    } catch (e) {
                        console.log(e)
                    }
                // } catch (e) {
                //     console.log(e)
                // }

                
            },

        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.greenT {
    color: #2DBAA5;
}

.lightGreenT {
    color: #76C819;
}

.orangeT {
    color: #FA6241;
}

.grayT {
    color: #B7B2AF;
}

.phoneFeeDetail {
    min-height: calc(100vh - 88px);
    width: 100%;
    min-width: 1104px;
}

// 标题
.titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleBox b {
    color: #2B2727;
    font-size: 15px;
}

.titleBox span {
    color: #7F7F7F;
    font-size: 13px;
}

.titleBox .titRiImg {
    width: 76px;
    height: 24px;
}

// 列表顶部标题
.titleLine {
    width: 100%;
    height: 20px;
    margin-top: 12px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleLine span {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
}

.titleLine span::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 20px;
    margin-right: 6px;
    background: #FA6241;
    vertical-align: middle;
}

// 灰色标题
.grayTltleLine {
    width: 100%;
    height: 32px;
    line-height: 32px;
    background: #EEEEEE;
    padding-left: 14px;
    font-size: 12px;
    font-weight: bold;
}


// 第一行内容
.orderDeBotpC {
    margin-top: 15px;
}

.boxTitle {
    width: 100%;
    height: 48px;
    line-height: 48px;
    padding-left: 12px;
    background: #EEEEEE;
    color: #2B2727;
    font-size: 13px;
    font-weight: bold;
}

.orderDeBotpC .comBox {
    width: 100%;
    height: calc(100% - 48px);
    padding: 0 12px;
    color: #333333;
    font-size: 12px;
}

.orderDeBotpC .comBox .topLine {
    width: 100%;
    height: 32px;
    box-shadow:0px 1px 0px rgba(238,238,238,1);
}
.orderDeBotpC .comBox .topLine img {
    width: 14px;
    height: 14px;
    margin-right: 3px;
}

.orderDeBotpC .comBox .midArea {
    width: 100%;
    line-height: 20px;
    padding-top: 13px;
    box-shadow:0px 1px 0px rgba(238,238,238,1);
}

.orderDeBotpC .comBox .botLine {
    width: 100%;
    height: 45px;
    color: #FA6241;
    
}
.orderDeBotpC .comBox .botLine b {
    font-size: 16px;
    font-weight: bold;
}


// --------------------------------账单信息-start-------------------------------
.billInfo {
    width: 25%;
    min-width: 269px;
    background: #fff;
    overflow: hidden;
}
// -------------------------------- 账单信息-end -------------------------------


// --------------------------------分账信息-start-------------------------------
.subAccountInfo {
    width: 25%;
    min-width: 269px;
    height: 226px;
    background: #fff;
    overflow: hidden;
    margin-left: 12px;
}
// -------------------------------- 分账信息-end -------------------------------


// --------------------------------资金流水信息-start-------------------------------
.moneyFlowInfo {
    width: 47.769%;
    // min-width: 514px; // UI
    // min-width: 548px;
    min-width: 566px;
    height: 226px;
    background: #fff;
    margin-left: 12px;
}

.moneyFlowInfo .noData {
    width: 100%;
    height: calc(100% - 48px);
}
.moneyFlowInfo .noData img {
    width: 72px;
    height: 72px;
}

.moneyFlowInfo .topLine2 {
    width: 100%;
    height: 32px;
    padding-left: 14px;
    color: #333333;
    font-size: 12px;
}

.moneyFlowInfo .botTable {
    width: 100%;
    // height: calc(100% - 48px - 32px);
    color: #333333;
    font-size: 12px;
}
.moneyFlowInfo .botTable .greenT {
    color: #2DBAA5;
    font-size: 12px;
}
// -------------------------------- 资金流水信息-end -------------------------------


// --------------------------------稽核冲账日志-start-------------------------------
.auditAccountLog {
    margin-top: 14px;
}
.auditAccountLog .tableTheadDarkGray {
    margin-top: 12px;
    min-width: 875px;
    font-size: 12px;
}
// -------------------------------- 稽核冲账日志-end -------------------------------


// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
}
// 弹窗按钮-绿色按钮
.submitGreenBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #2DBAA5;
    color: #FFFFFF;
    &:hover {
      background-color: rgb(150, 190, 184);
    }
    margin-left: 20px;
}

</style>
